import React, { Component } from 'react';
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import '../style/App.css';

//required Props receive and/or pass back to parent:
// - this.props.handleComment(value) to pass up values to state (for sending to backend, passed up)
// - this.props.commentTitle (title of TextField, passed down)
// - this.props.comment (content of TextField, pass up and down)

class ContactComment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      comment: ''
    }
    this.handleComment = this.handleComment.bind(this);
  }

  handleComment(value) {
    // console.log('ContactComment - hanldeComment(): ', value);
    this.props.handleComment(value);
    // this.setState({
    //   comment: value
    // })
  }

  componentDidMount() {
    // console.log('compDidMt in ContactComment - PROPS: ', this.props);
    if (this.props.comment) {
      console.log('comment: ', this.props.comment)
      this.setState({
        comment: this.props.comment
      })
    }
  }

  render() {
    return (
      <div className='contactFormFieldHolder'>
        <TextField
          onChange={(e) => this.handleComment(e.target.value)}
          fullWidth
          multiline
          rows='7'
          variant="outlined"
          id="comment-form"
          label={this.props.commentTitle}
          value={this.props.comment}
          sx={{
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgb(125, 120, 120)'
            },
            '& .MuiInputLabel-root': {
              color: 'rgb(125, 120, 120)'
            }
          }}
        />
      </div>
    )
  }

}

export default ContactComment;
